import React, { useState } from "react";
import axios from "axios";
import { IoIosArrowDown } from "react-icons/io";

import { IoMdClose } from "react-icons/io";
import AmlBadge from "./AmlBadge";

const AmlCheckModal = ({ selectedUser, setAmlModalOpen, setRender }) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [amlSelected, setAmlSelected] = useState("");
  const [textCount, setTextCount] = useState(0);
  const [amlComment, setAmlComment] = useState("");
  const [error, setError] = useState("");

  const handleAmlUpdate = async (state) => {
    const errorMessage = validateInput();
    if (errorMessage) {
      setError(errorMessage);
      return;
    }
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${selectedUser.uuid}/update_user_aml_status`,
        //https://api.dpiwealth.com/lender/v1/users/9286d3cf-f9a5-4052-a7de-8e2b812577bc/update_user_aml_status

        method: "PATCH",
        headers: { Authorization: token },
        data: {
          from_status: selectedUser?.status,
          to_status: amlSelected,
          comment: amlComment,
        },
      };
      const res = await axios(options);
      // console.log(res);

      if (res.status === 200) {
        setRender((prev) => !prev);
        setAmlModalOpen(false); // close the modal
      }
    } catch (error) {
      setError("An error occured, please try again");
    } finally {
    }
  };
  const amlStatus = [
    {
      status: "low_risk",
    },
    {
      status: "medium_risk",
    },

    {
      status: "high_risk",
    },
    {
      status: "blocked",
    },
  ];
  const validateInput = () => {
    if (!amlSelected) return "Please select a status to save";
    if (!amlComment.length) return "Please enter a comment to save";
    return null;
  };

  return (
    <div className="overlay z-50">
      <div className={`modal !w-[340px]  !h-[385px] !p-0 !text-left `}>
        <div className=" w-full h-full p-6 flex flex-col">
          <div className=" flex justify-between items-center text-base font-bold">
            <p>AML Check Edit</p>
            <IoMdClose
              className=" w-[20px] h-[20px] cursor-pointer"
              onClick={() => setAmlModalOpen(false)}
            />
          </div>
          <p className="mt-4 text-sm font-semibold">
            {selectedUser?.name || "---"}
          </p>
          <div className=" mt-4 w-full flex">
            <div className="">
              <p className=" text-sm mb-2 font-medium">From:</p>
              <AmlBadge status={selectedUser?.status} />
            </div>
            <div className=" ml-4">
              <p className=" text-sm mb-2 font-medium">To:</p>
              {/* /// */}
              <button
                onClick={() => setOpenFilter(!openFilter)}
                className=" relative py-2 px-[9px] z-20 flex justify-between items-center bg-[#f8f8f8] text-[#6f6f6f] rounded w-[130px] h-[20px] text-xs   focus:outline-none font-semibold shadow-sm"
              >
                {amlSelected ? <AmlBadge status={amlSelected} /> : "Select"}
                <span>
                  <IoIosArrowDown
                    className=" transition-all ease-in-out duration-100"
                    style={{
                      transform: openFilter ? "rotate(180deg)" : "rotate(0deg)",

                      color: "#00394d",
                      width: 14,
                      height: 14,
                    }}
                  />
                </span>
              </button>
              {openFilter && (
                <div className="bg-white mt-1 absolute w-[150px] h-fit rounded-[6px] p-3 pt-0 shadow-lg">
                  {amlStatus.map((item, index) => {
                    if (selectedUser.status === item.status) {
                      return null;
                    }
                    return (
                      <div className="flex items-center mt-4">
                        <input
                          checked={amlSelected === item.status}
                          type="radio"
                          className=" mr-4"
                          name={"aml"}
                          onChange={() => {
                            setAmlSelected(item.status);
                            setOpenFilter(false);
                          }}
                        />
                        <AmlBadge status={item.status} />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
          <p className=" mt-4 text-sm font-medium">Comment(150 characters)</p>
          <textarea
            value={amlComment}
            maxLength={150}
            onChange={(e) => {
              if (error === "Please enter a comment to save") {
                setError("");
              }
              setTextCount(e.target.textLength);
              setAmlComment(e.target.value);
            }}
            className={` resize-none mt-2 border  ${
              error === "Please enter a comment to save"
                ? " border-red-600"
                : "border-[#e0e0e0]"
            } rounded h-[100px] focus:outline-none focus:border-[#00394d] text-sm p-2`}
          />
          <div className=" ml-1 mt-1 flex justify-between text-[10px] pr-[2px]">
            <p className="  text-[#262626]">{textCount}/150</p>
            {error && <p className=" text-red-600">{error}</p>}
          </div>

          <button
            onClick={() => handleAmlUpdate()}
            className=" mt-3  ml-auto mr-auto bg-[#00394d] w-[65px] h-[32px] rounded text-white text-sm font-semibold"
          >
            Save
          </button>
        </div>

        {/* {succesState && !downloadLoading && (
          <div className=" w-full h-full flex justify-center flex-col items-center">
            <SuccessImage />
            <p className=" font-bold  text-base mt-2">Download, successful!</p>
          </div>
        )}
        {downloadLoading && (
          <div className=" w-full h-full flex justify-center flex-col items-center">
            <ImageLoading />
          </div>
        )} */}
      </div>
    </div>
  );
};

export default AmlCheckModal;
